import React from "react";
import ReactDOM from "react-dom";
import { hot } from "react-hot-loader/root";
import { ConfigProvider } from "antd";
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import { Platform, Auth, PaymentResult } from "./components";
import "./index.less";
import { useStores } from "./store";
import { Restaurant } from "./pages";
import matomo from "./service/matomo";

function App() {
  const { memberStore } = useStores();
  const locale = memberStore.getLocale();
  return (
    <Auth>
      <Router>
        <ConfigProvider locale={locale}>
          <div className="page-main">
            <main>
              <Switch>
                <Route path="/restaurants/:id" component={Restaurant}></Route>
                <Route
                  path="/paymentResult/:paymentStr"
                  component={PaymentResult}
                ></Route>
              </Switch>
            </main>
            <Platform></Platform>
          </div>
        </ConfigProvider>
      </Router>
    </Auth>
  );
}

async function bootstrap() {
  const WithHotReload = process.env.NODE_ENV === "production" ? App : hot(App);
  ReactDOM.render(<WithHotReload />, document.getElementById("root"));
  const appHeight = () => {
    const doc = document.documentElement;
    const userAgent = window.navigator.userAgent.toLowerCase();
    const barHeight = 0
    function has(key) {
      return userAgent.indexOf(key) > -1;
    }
    if(has("micromessenger") || has("dingtalk") || has("alipay")) {
      barHeight = 44
    }
    // 在微信或者钉钉，支付宝客户端内，需要增加额外的高度
    doc.style.setProperty('--app-height', `${window.innerHeight + barHeight}px`)
  }
  window.addEventListener('resize', appHeight)
  appHeight()
}
matomo();
bootstrap();
